import Layout from '../components/layout'
import Head from 'next/head'
import HeaderPWA from '../components/header'
import Image from 'next/image'
import Link from 'next/link'
import { sendMessageApi } from '../lib/api'
import { useRouter } from 'next/router'
import ContactAlpha from '../components/contact-alphalives'


export default function contact({siteEnv}) {

    const router = useRouter();

    var erreur;
    const website_url = siteEnv == 'pwafr'? 'https://www.progressive-web-apps.fr/' : 'https://www.alphalives.com/';
    const metaDescription = siteEnv == 'pwafr'? 
    "Progressive-web-apps.fr est un site français spécialisé sur les applications web progressives ou PWA. Nous proposons des articles, comparatifs, tutoriels par spécifiques à ce domaine."
    : 'Alphalives, agence spécialisée dans le développement sur mesure. Logiciels métiers sur mesure, Sites internet, Application mobiles, Newsletters, Landing pages';

    const sendMessage = async (e) => {
        erreur = '';
        var env = siteEnv?.siteEnv || siteEnv
        e.preventDefault()
        //console.log(e.target.name.value);
        const result = await sendMessageApi(e.target, env);
        //console.log('result', result);
        if (result['envoyé']) {
            router.push('/contact-success');
        } else {
            if (result['erreur']) {
                erreur = result['erreur'];
            } else {
                erreur = 'Erreur lors de l\'envoi du message.';
            }
            document.getElementById('erreur').innerHTML = erreur;
        }
    }

    const test = (e) => {
        e.preventDefault()
        //console.log(siteEnv.siteEnv);
    }
    
    return (
        <>
            {siteEnv == 'alphalives' && <ContactAlpha siteEnv={siteEnv} metaDescription={metaDescription} websiteUrl={website_url}></ContactAlpha>}
            {siteEnv == 'pwafr' && 
            (
                <>
                    <Layout siteEnv={siteEnv} >
                        <Head>
                            <title>Contact</title>
                            <meta name="description" content={metaDescription} />
                            <meta name="viewport" content="width=device-width,initial-scale=1.0,minimum-scale=1,user-scalable=yes"/>
                            <meta name="robots" content="index, follow"/>
                            <meta property="og:locale" content="fr"/>
                            <meta property="og:site_name" content={siteEnv == "pwafr"? 'progressive-web-apps' : 'alphalives'}/>
                            <meta property="og:type" content={siteEnv == "pwafr"? 'website' : 'article'} />
                            <meta name="og:url" content={website_url+ 'contact'} />
                            <meta property="fb:app_id" content="1795695950672896"/>
                            <meta property="og:title" content="Contact" /> 
                            <meta name="og:description" content={metaDescription} />
                            <meta name="twitter:card" content="photo"/>
                            <meta name="twitter:site" content={siteEnv == "pwafr"? '@alphalives' : '@alphalives'}/>
                            <meta name="twitter:creator" content={siteEnv == "pwafr"? '@alphalives' : '@alphalives'}/>
                            <meta name="twitter:url" content={website_url+ 'contact'} /> 
                            <meta name="twitter:title" content="Contact" /> 
                            <meta name="twitter:description" content={metaDescription} />
                            <link href={website_url + 'contact'} rel="canonical"/>
                        </Head>
                        <div className="bg-screen contactMinScreen">
                            <HeaderPWA />
                            
                            <section className="py-28 text-white text-center bg-fixed relative" id="contact">
                                <Image className="z-10 absolute inset-0 object-cover" layout='fill' src="/imgs/img-bg-sombre.jpg" />

                                <div className="container mx-auto px-5 grid grid-cols-1 gap-4 relative z-20 bg-transparent lg:grid-cols-12">
                                    <div className="col-span-1 lg:col-start-3 lg:col-span-8">
                                        <h1 className="text-6xl font-light leading-10 mb-4">Formulaire de contact</h1>
                                    </div>
                                </div>
                            </section>

                            <section className="container mx-auto px-5 grid gap-4 grid-cols-1 py-4 lg:grid-cols-12">
                                <div className="lg:col-start-3 col-span-1 lg:col-span-8 text-left">
                                    <Link href="/">
                                        <a className="text-color-primary">Accueil </a>
                                    </Link>
                                    › <Link href="/">
                                        <a> Contact </a>
                                    </Link>
                                </div>
                            </section>
                            
                            <section>
                                <div className="container mx-auto px-5 py-14 grid gap-4 grid-cols-1 relative z-20 bg-transparent lg:grid-cols-12">
                                    <div className="lg:col-span-8 lg:col-start-3 col-span-1">
                                        <form onSubmit={sendMessage}>
                                            <div className="grid gap-4 lg:grid-cols-2 grid-cols-1">

                                                <div className="col-span-1">
                                                    <div className="md-input-box">
                                                        <input
                                                            id="name"
                                                            name="name"
                                                            type="text"
                                                            className="md-input"
                                                            placeholder=" "
                                                        />
                                                        <label htmlFor="name" className="md-label">Nom</label>
                                                        <div className="md-input-underline" />
                                                    </div>
                                                </div>
                                                <div className="col-span-1">
                                                    <div className="md-input-box">
                                                        <input
                                                            id="firstName"
                                                            name="firstName"
                                                            type="text"
                                                            className="md-input"
                                                            placeholder=" "
                                                        />
                                                        <label htmlFor="firstName" className="md-label">Prénom</label>
                                                        <div className="md-input-underline" />
                                                    </div>
                                                </div>
                                                <div className="col-span-1">
                                                    <div className="md-input-box">
                                                        <input
                                                            id="email"
                                                            name="email"
                                                            type="text"
                                                            className="md-input"
                                                            placeholder=" "
                                                        />
                                                        <label htmlFor="email" className="md-label">Email</label>
                                                        <div className="md-input-underline" />
                                                    </div>
                                                </div>
                                                <div className="col-span-1">
                                                    <div className="md-input-box">
                                                        <input
                                                            id="tel"
                                                            name="tel"
                                                            type="text"
                                                            className="md-input"
                                                            placeholder=" "
                                                        />
                                                        <label htmlFor="tel" className="md-label">Tel</label>
                                                        <div className="md-input-underline" />
                                                    </div>
                                                </div>
                                                <div className="lg:col-span-2 col-span-1">
                                                    <div className="md-input-box">
                                                        <textarea
                                                            id="message"
                                                            name="message"
                                                            type="text"
                                                            className="md-input"
                                                            placeholder=" "
                                                            rows="1"
                                                        />
                                                        <label htmlFor="message" className="md-label">Message</label>
                                                        <div className="md-input-underline" />
                                                    </div>
                                                </div>
                                                
                                                <div className="lg:col-span-2 mt-4 col-span-1">
                                                <div className="erreur" id="erreur">
                                                </div>
                                                    <button className="btn shadow-lg block btn-secondary mx-auto">Envoyer</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </section>

                        </div>
                    </Layout>
                
                </>
            )}
        </>
    )
}

export async function getStaticProps({ preview = false }) {
  const siteEnv = process.env.CONTENTFUL_SITE_TAG ?? "pwafr"


  return {
    props: {
      preview,
      siteEnv,
    },
  }
}